import { render, staticRenderFns } from "./StatsBar.vue?vue&type=template&id=23442e26&scoped=true"
import script from "./StatsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StatsBar.vue?vue&type=style&index=0&id=23442e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23442e26",
  null
  
)

export default component.exports